module.exports = __webpack_public_path__ + "static/media/lock.35f7d126.jpeg";